export const addNotification = (notification) => ({
    type: 'ADD_NOTIFICATION',
    payload: notification,
  });
  // console.log('====================================');
  // console.log('Notification action called', addNotification); 
  // console.log('====================================');
  
  export const clearNotifications = () => ({
    type: 'CLEAR_NOTIFICATIONS',
  });
  